let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5Y5Hm")).then(() => parcelRequire('ftHHC'));